import firebase from "services/FirebaseService";
import { dispatch } from "whiteboard/AppStore";

const db = firebase.firestore();

const linkAccountToSubscription = firebase.functions().httpsCallable("linkAccountToSubscription");
const addSubscription = firebase.functions().httpsCallable("addSubscription");

const defaultState = {
  hasSubscription: false,
  ready: false,
  subscription: {
    maxDataMods: 0,
    maxPDFMods: 0,
    level: 0
  }
};

function getSubscriptionInfo(email, showAll) {
  return new Promise(async (resolve, reject) => {
    try {
      const limit = showAll ? 30 : 1;
      const subscriptionRef = await db
        .collection("subscriptions")
        .where("email", "==", email)
        .where("expires", ">=", new Date())
        .orderBy("expires", "desc")
        .limit(limit)
        .get();

      if (subscriptionRef.size <= 0) {
        return resolve({ ready: true });
      } else {
        const subscriptionDocs = subscriptionRef.docs;
        const subscriptionDoc = subscriptionDocs[0];
        const subscriptionData = subscriptionDoc.data();
        const expires = subscriptionData.expires.toDate();
        const subscription = { ...subscriptionData, expires, id: subscriptionDoc.id };
        let out = { subscription, hasSubscription: true, ready: true };
        if (showAll) {
          out.subscriptions = subscriptionDocs.map(doc => {
            let item = doc.data();
            item.id = doc.id;
            item.expires = item.expires.toDate();
            return item;
          });
        }
        return resolve(out);
      }
    } catch (e) {
      return reject(e);
    }
  });
}

const model = {
  state: defaultState,
  reducers: {
    setState(state, option) {
      return { ...state, ...option };
    }
  },
  effects: {
    async deleteDataMod(dataMod, rootState) {
      try {
        await db
          .collection("data-mods")
          .doc(dataMod.id)
          .delete();
      } catch (e) {
        console.error(e);
      }
    },
    async deletePDFMod(dataMod, rootState) {
      try {
        await db
          .collection("pdf-mods")
          .doc(dataMod.id)
          .delete();
      } catch (e) {
        console.error(e);
      }
    },
    async editPDFMod(data, rootState) {
      const { id, ...otherValues } = data;
      try {
        await db
          .collection("pdf-mods")
          .doc(id)
          .update(otherValues);
      } catch (e) {
        alert(`There was a problem saving PDF settings ${e.message}`);
      }
    },
    async profileUpdated(profile, rootState) {
      // console.log("profileUpdated", profile, rootState);
      dispatch.account.getSubscription(profile);
    },
    async linkAccountToSubscription(payload, rootState) {
      try {
        const result = await linkAccountToSubscription();
        dispatch.account.getSubscription();
      } catch (e) {
        console.error(e);
        alert(e.message);
      }
    },
    async addSubscription(subscription, rootState) {
      try {
        const result = await addSubscription(subscription);
      } catch (e) {
        console.error(e);
      }
    },
    async getUserInfo(userSearchObj, rootState) {
      const { email } = userSearchObj;
      try {
        const userRef = await db
          .collection("users")
          .where("email", "==", email)
          .get();
        const userDoc = userRef.docs[0];
        const user = userDoc.data();
        const subscription = await getSubscriptionInfo(email, true);
        console.log({ user, subscription });
        dispatch.auth.ghost(user);
      } catch (e) {
        console.error(e);
      }
    },
    async getLatestUsers(userSearchObj, rootState) {
      try {
        const userRef = await db
          .collection("users")
          .orderBy("createdAt", "desc")
          .limit(10)
          .get();
        const docs = userRef.docs.map(ref => {
          const data = ref.data();
          const id = ref.id;
          const createdAt = data.createdAt.toDate();
          return { ...data, id, createdAt };
        });
        console.log("users", docs);
      } catch (e) {
        console.error(e);
      }
    },
    async getLatestSubscriptions(userSearchObj, rootState) {
      try {
        const userRef = await db
          .collection("subscriptions")
          .orderBy("createdAt", "desc")
          .limit(10)
          .get();
        const docs = userRef.docs.map(ref => {
          const data = ref.data();
          const id = ref.id;
          const createdAt = data.createdAt.toDate();
          const expires = data.expires.toDate();
          return { ...data, id, createdAt, expires };
        });
        console.log("subscriptions", docs);
      } catch (e) {
        console.error(e);
      }
    },
    async getSubscription(payload, rootState) {
      // console.log("getSubscription", payload, rootState);
      const uid = rootState.auth.profile.uid;
      const email = rootState.auth.profile.email;
      try {
        const subscription = await getSubscriptionInfo(email);
        this.setState(subscription);
      } catch (e) {
        console.error(e);
      }
      dispatch.ui.profileUpdated(rootState.auth.profile);
    }
  }
};

export default model;



// WEBPACK FOOTER //
// ./src/whiteboard/models/account.js